import { createContext, useState } from 'react';

// name of the flags created in the backend must coincide with the names in this object
export const featureTags = {
  CREATE_JOBS: 'create_jobs_v2', //placeholder
  DELETE_JOBS: 'delete_jobs_v2', //placeholder
  LOGGED_IN_JOB_BOARD: 'logged_in_job_board',
  FLAT_FILE_TRANSFERS: 'flat_file_transfers',
  SOURCE_FILTER: 'source_filter',
  BULK_FORMS: 'bulk_forms',
  JOB_REQUEST_UPDATE: 'job_request_update',
  DEPRECATE_LOCAL_QUESTION_SETS: 'deprecate_local_question_sets',
  CANNOT_ADD_SCHOOLS: 'cannot_add_schools',
  ATS_CREDENTIAL_VERIFICATION: 'ats_credential_verification',
  UPDATED_LOCATIONS_MODAL: 'updated_locations_modal',
  DISABLE_WORK_AUTHORIZATION_BADGE: 'disable_work_authorization_badge',
} as const;

type FeatureTagKey = keyof typeof featureTags;
type FeatureTagValue = (typeof featureTags)[FeatureTagKey];

export class Features {
  feature_name: FeatureTagValue;
  feature_enabled: boolean;

  constructor(feature_name: FeatureTagValue, feature_enabled: boolean) {
    this.feature_name = feature_name;
    this.feature_enabled = feature_enabled;
  }
}

export interface FeatureContextValue {
  features: string[];
  setFeatures: React.Dispatch<React.SetStateAction<string[]>>;
}

const Context = createContext<FeatureContextValue>({
  features: [],
  setFeatures: () => {},
});

interface FeatureContextProviderProps {
  children: React.ReactNode;
}

export const FeatureContextProvider: React.FC<FeatureContextProviderProps> = ({ children }) => {
  const [features, setFeatures] = useState<string[]>([]);

  return <Context.Provider value={{ features, setFeatures }}>{children}</Context.Provider>;
};

export default Context;
